import type { ConversationItem } from '@vivport/backend/types';
import { useNavigateWithContentFlush } from '@/hooks';
import { Navigation } from 'lucide-react';

type ViewNavigationItem = Extract<ConversationItem, { kind: 'view_navigation' }>;

export interface ProvenanceViewNavigationChipProps {
  item: ViewNavigationItem;
}

export function ProvenanceViewNavigationChip({ item }: ProvenanceViewNavigationChipProps) {
  const navigate = useNavigateWithContentFlush();
  return (
    <button
      type="button"
      onClick={() => navigate(item.url)}
      className="inline-flex items-center gap-2 text-xs text-muted-foreground transition-colors hover:text-foreground"
    >
      <Navigation className="h-3.5 w-3.5 shrink-0" />
      <span className="min-w-0 truncate">Opened {item.title ?? item.code}</span>
    </button>
  );
}
